import styled from 'styled-components'
import { Button } from '../design-system/Button'

export const modalStyle: ReactModal.Styles = {
  content: {
    padding: 0,
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
    height: '94%',
    border: '1px solid #dfe2e5'
  }
}

export const ModalHeader = styled.div`
  border: none;
  display: flex;
  padding: 0 20px;
  height: 55px;
  flex-direction: row;
`

export const ModalContent = styled.div<{ withoutTopBorder?: boolean }>`
  flex: 1;
  overflow: auto;
  padding: 20px;
  scroll-behavior: smooth;
  border-bottom: 1px solid #dfe2e5;
  ${({ withoutTopBorder }) => (withoutTopBorder ? '' : 'border-top: 1px solid #dfe2e5;')}
`

export const ModalFooter = styled.div`
  display: flex;
  padding: 10px;
  overflow: auto;
  justify-content: flex-end;
`

export const ModalFooterButton = styled(Button)`
  margin: 8px 6px;
  z-index: 1001;
  min-width: 86px;
  height: 34px;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 0 ${({ disabled }) => (disabled ? 0 : 1)} px #1585d8;
`
